import { Link } from "react-router-dom";
import { LinkedinLogo, MapPin, Phone, EnvelopeSimple, ArrowUpRight } from "@phosphor-icons/react";
import { NAV, SERVICES, CONTACT } from "../data/content";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ballk-pm/artifacts/qei90dxd_Logo%20Nieuw%20ChatGPT%20Image%2013%20jul%202026%2C%2012_55_25.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#EEF0F3] text-ballk-indigo border-t border-ballk-light">
      <div className="container-ballk py-20">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <img src={LOGO_URL} alt="BALLK Project" className="h-24 w-auto object-contain mb-6" />
            <p className="text-sm text-ballk-steel leading-relaxed max-w-xs">
              Projectmanagement met overzicht, vertrouwen en resultaat binnen de vastgoedsector.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-xs uppercase tracking-widest text-ballk-steel mb-5">Navigatie</h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-sm text-ballk-indigo hover:text-ballk-purple transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-xs uppercase tracking-widest text-ballk-steel mb-5">Diensten</h4>
            <ul className="space-y-3">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link to="/diensten" className="text-sm text-ballk-indigo hover:text-ballk-purple transition-colors">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-xs uppercase tracking-widest text-ballk-steel mb-5">Contact</h4>
            <ul className="space-y-4 text-sm text-ballk-indigo">
              <li className="flex gap-3"><MapPin size={20} className="text-ballk-purple shrink-0" /><span>{CONTACT.address}</span></li>
              <li className="flex gap-3"><Phone size={20} className="text-ballk-purple shrink-0" /><a href={`tel:${CONTACT.phone}`} className="hover:text-ballk-purple transition-colors">{CONTACT.phone}</a></li>
              <li className="flex gap-3"><EnvelopeSimple size={20} className="text-ballk-purple shrink-0" /><a href={`mailto:${CONTACT.email}`} className="hover:text-ballk-purple transition-colors">{CONTACT.email}</a></li>
              <li>
                <a href={CONTACT.linkedin} target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-2 mt-1 text-ballk-purple hover:text-ballk-purple-dark transition-colors font-medium">
                  <LinkedinLogo size={20} weight="fill" /> LinkedIn <ArrowUpRight size={14} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-ballk-light flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-ballk-steel">© {new Date().getFullYear()} BALLK Project. Alle rechten voorbehouden.</p>
          <p className="text-xs text-ballk-steel">Overzicht · Vertrouwen · Resultaat</p>
        </div>
      </div>
    </footer>
  );
}
